// Import types
import { CREATE_QUANTITYIMPORT_REQUEST, LOOKUP_QUANTITYIMPORT_REQUEST, QUANTITYIMPORT_RESET } from './types';

// Export operations
/**
 * Dispatch for applying a reviewed quantity import.
 * @param {Object} { token: string, payload: object }
 * @return {Object} Dispatch
 */
export const doCreateQuantityImport = ({ token, payload }) => ({
  type: CREATE_QUANTITYIMPORT_REQUEST,
  token,
  payload,
});

/**
 * Dispatch for resolving product codes to their products.
 * @param {Object} { token: string, payload: object }
 * @return {Object} Dispatch
 */
export const doLookupQuantityImport = ({ token, payload }) => ({
  type: LOOKUP_QUANTITYIMPORT_REQUEST,
  token,
  payload,
});

/**
 * Dispatch for resetting the quantity import reducer
 * @param {Object} {  }
 * @return {Object} Dispatch
 */
export const doQuantityImportReset = () => ({
  type: QUANTITYIMPORT_RESET,
});
